import React from "react";
import Image from "next/image";
import logo from "../../../public/assets/images/brand/logo 11.png";
import { ShareButton } from "../button/Jobs/ShareButton";

export interface JobHeaderProps {
  jobTitle: string;
  jobId: string;
  postDate: string; 
  isAvailable: boolean; 
}

const JobHeader: React.FC<JobHeaderProps> = ({ jobTitle, jobId, postDate, isAvailable }) => {
  const lang =
  typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";
const isArabic = lang === "ar";
  return (
    <div className="self-stretch flex-col justify-start items-end gap-4 flex ">
      <div className="self-stretch justify-between items-center inline-flex">
        <ShareButton jobId={jobId} />
        <div className="justify-start items-center gap-2 flex ">
          <div className="w-[139px] flex-col justify-start items-end gap-1 inline-flex">
            <div className="self-stretch text-end text-[#202835] dark:text-gray-200 text-base font-bold  leading-snug">
             {isArabic ? "واحة الذكاء" : "Smart Oasis"}
            </div>
          </div>
          <div className="h-12 pl-0.5 pr-[1.94px] pt-[3px] rounded-[40px] border border-[#4f8be0] justify-center items-center flex">
            <div className="w-[44.06px] h-14 relative flex items-center justify-center">
              <Image
                className="scale-90 rounded-full"
                src={logo}
                alt="smart oasis logo"
                width={64}
                height={64}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="self-stretch justify-between items-center inline-flex">
        <div className="justify-start items-center gap-1 flex">
          <div className="text-[#414c5d] dark:text-gray-300 text-sm font-normal leading-tight">
             {isArabic ? "تاريخ الانشاء:" : "Post Date:"} {postDate?.split("T")[0]}
          </div>
        </div>
        <div className={`sm:px-[18px] px-[18px] sm:py-1.5 py-1 dark:bg-teal-950 rounded justify-center items-center gap-2 flex ${isAvailable ? "bg-green-50" : "bg-red-50"}`}>
          <div className={`text-xs font-normal leading-none ${isAvailable ? "text-green-500" : "text-red-500"}`}>
            {isAvailable ?
            isArabic ? "التقديم متاح" : "Available" : isArabic ? "غير متاح" : "Not Available"}
          </div>
          <div className={`w-[9px] h-[9px] rounded-full ${isAvailable ? "bg-green-500" : "bg-red-500"}`} />
        </div>
      </div>
      <div className="self-stretch flex-col justify-start items-end gap-4 flex">
        <div className="self-stretch text-start text-[#4f8be0] dark:text-primary sm:text-xl text-[22px] font-semibold leading-7 h-[66px] overflow-hidden">
          {jobTitle}
        </div>
      </div>
    </div>
  );
};

export default JobHeader;
